import SEO from '@/components/feature/SEO';
import HeroSearch from './components/HeroSearch';
import CategoryGrid from './components/CategoryGrid';
import HotResources from './components/HotResources';
import LatestResources from './components/LatestResources';
import HomeFAQ from './components/HomeFAQ';
import CTASection from './components/CTASection';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '磁力猫',
  url: 'https://www.ciligod.com',
  description: '磁力猫是专业的磁力链接搜索引擎，提供海量影视、音乐、软件、电子书等资源的磁力链接免费搜索与下载服务。',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://www.ciligod.com/category/all?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '磁力猫',
  url: 'https://www.ciligod.com',
  description: '专业的磁力链接搜索引擎',
  logo: 'https://www.ciligod.com/logo.png',
  sameAs: [
    'https://www.ciligod.com',
  ],
};

const webPageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '磁力猫 - 海量资源免费搜索与下载',
  description: '磁力猫是专业的磁力链接搜索引擎，提供海量影视、音乐、软件、电子书等资源的磁力链接免费搜索与下载服务。',
  url: 'https://www.ciligod.com',
  isPartOf: {
    '@type': 'WebSite',
    name: '磁力猫',
    url: 'https://www.ciligod.com',
  },
};

export default function Home() {
  return (
    <>
      <SEO
        title="海量资源免费搜索与下载"
        description="磁力猫是专业的磁力链接搜索引擎，提供海量影视、音乐、软件、电子书等资源的磁力链接免费搜索与下载服务。使用磁力猫快速找到你想要的一切资源，支持BT种子转磁力，操作简单，资源丰富。"
        keywords="磁力猫,磁力猫搜索引擎,磁力链接搜索,磁力猫资源下载,BT磁力搜索,磁力猫免费资源,磁力猫影视资源"
        canonicalUrl="https://www.ciligod.com"
        ogUrl="https://www.ciligod.com"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageJsonLd) }}
      />
      <HeroSearch />
      <CategoryGrid />
      <HotResources />
      <LatestResources />
      <HomeFAQ />
      <CTASection />
    </>
  );
}